import React, { useState } from "react";
import { Link } from "react-router-dom";
import DuesSetup from "../../../components/AssociationAdmin/Dues/Setup";
import DuesApplication from "../../../components/AssociationAdmin/Dues/Application";

const AssociationAdminDuesPage = () => {
  const [activeTab, setActiveTab] = useState("pill-justified-dues-setup"); // Initial active tab

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <>
      {/* <!-- start page title --> */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Dues</h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/app">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Dues</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- end page title --> */}

      <div className="row">
        <div className="col-lg-4">
          <ul className="nav nav-pills nav-justified mb-3" role="tablist">
            <li
              className="nav-item waves-effect waves-light"
              role="presentation"
            >
              <button // Use a button instead of <a>
                className={`nav-link ${
                  activeTab === "pill-justified-dues-setup" ? "active" : ""
                }`}
                onClick={() => handleTabChange("pill-justified-dues-setup")} // Handle click
              >
                Dues Type Management
              </button>
            </li>
            <li
              className="nav-item waves-effect waves-light"
              role="presentation"
            >
              <button // Use a button
                className={`nav-link ${
                  activeTab === "pill-justified-dues-application"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  handleTabChange("pill-justified-dues-application")
                } // Handle click
              >
                Dues Application
              </button>
            </li>
          </ul>
        </div>
        <div className="col-lg-12">
          <div className="tab-content">
            <div
              className={`tab-pane ${
                activeTab === "pill-justified-dues-setup" ? "active show" : ""
              }`}
              id="pill-justified-dues-setup"
              role="tabpanel"
            >
              <DuesSetup isActive={activeTab === "pill-justified-dues-setup"} />{" "}
              {/* Pass isActive */}
            </div>
            <div
              className={`tab-pane ${
                activeTab === "pill-justified-dues-application"
                  ? "active show"
                  : ""
              }`}
              id="pill-justified-dues-application"
              role="tabpanel"
            >
              <DuesApplication
                isActive={activeTab === "pill-justified-dues-application"}
              />{" "}
              {/* Pass isActive */}
            </div>
          </div>
        </div>
      </div>
      {/* <!--end row--> */}
    </>
  );
};

export default AssociationAdminDuesPage;
